module.exports = "/static/assets/2021652d26de5ace82ba052a6584e998.png";